
import { SiriusAppModule } from 'sirius-framework';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/modules/shared.module';
import { InnerMenuAccountRoutingModule } from './inner-menu-account.routing.module';

import { InnerMenuAccountComponent } from './inner-menu-account.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AccountService } from './inner-menu-account.service';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        InnerMenuAccountRoutingModule       
    ],
    declarations: [
        InnerMenuAccountComponent,
        ProfileComponent
    ],
    providers: [AccountService]
})
export class InnerMenuAccountModule extends SiriusAppModule { }
